var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8334 9.83317C10.8334 10.2932 10.4601 10.6665 10.0001 10.6665C9.54009 10.6665 9.16675 10.2932 9.16675 9.83317V6.49984C9.16675 6.03984 9.54009 5.6665 10.0001 5.6665C10.4601 5.6665 10.8334 6.03984 10.8334 6.49984V9.83317ZM10.0001 13.1665C9.54009 13.1665 9.16675 12.7932 9.16675 12.3332C9.16675 11.8732 9.54009 11.4998 10.0001 11.4998C10.4601 11.4998 10.8334 11.8732 10.8334 12.3332C10.8334 12.7932 10.4601 13.1665 10.0001 13.1665ZM18.8009 12.5857L12.4076 1.9865C11.9084 1.15984 11.0084 0.666504 10.0001 0.666504C8.99176 0.666504 8.09176 1.15984 7.59259 1.9865L1.19926 12.5857C0.725922 13.3715 0.711755 14.3165 1.16176 15.1132C1.64426 15.969 2.58176 16.4998 3.60676 16.4998H16.3934C17.4184 16.4998 18.3559 15.969 18.8384 15.1132C19.2884 14.3165 19.2743 13.3715 18.8009 12.5857Z",
    fill: "#F6AE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYellowWarning);
export default __webpack_public_path__ + "static/media/IconYellowWarning.f0a19d6f2cae0fcb7ad1bf9d045a95c2.svg";
export { ForwardRef as ReactComponent };